export enum ReportDetailTab {
  SERVICES = 'services',
  ANNEXES = 'annexes',
  CERTIFICATES = 'certificates',
  REFERENCES = 'references',
  NOTIFICATIONS = 'notifications',
  NOTES = 'comments',
  REPORT_CHANGES_HISTORY = 'reportChangesHistory',
  VIDEOS = 'videos'
}
